<template>
    <div class="add_new_item" @click="goToNew">
        <iconEvalNew />
    </div>
</template>

<script>
export default {
    name: 'TopbarAddPosition',
    components: {},
    methods:{
        goToNew(){
            this.$router.push('/positions/new')
        }
    }
}
</script>

<style lang="scss">

.add_new_item{
    display: flex;
    justify-content: center;
    align-items: center;
    svg{
        width: 40px;
        fill: $grey-light;
    }
}

</style>